(function(){
"use strict";
var CLE="va_logo",NOM="va_logo_name",TON="va_logo_tone",LIB="va_logos",SANS="va_sans_logo";
var alerte=false;
function lire(k){try{return localStorage.getItem(k)}catch(e){return null}}
function oter(k){try{localStorage.removeItem(k)}catch(e){}}
function poser(k,v){try{localStorage.setItem(k,v);return true}catch(e){return false}}
function copiesCompte(){var a=[];try{for(var i=0;i<localStorage.length;i++){var k=localStorage.key(i);if(k&&k.indexOf("va_acct:")===0&&k.slice(-6)===":logos")a.push(k)}}catch(e){}return a}
function degager(){var lib=lire(LIB);copiesCompte().forEach(function(k){var v=lire(k);if(v===null)return;if(lib===null){if(poser(LIB,v)){oter(k);lib=v}return}if(v===lib){oter(k)}})}
function choisi(){var nom=lire(NOM);if(!nom)return null;var lib;try{lib=JSON.parse(lire(LIB)||"[]")}catch(e){lib=[]}if(!lib||!lib.length)return null;for(var i=0;i<lib.length;i++){var L=lib[i];if(L&&L.name===nom&&typeof L.data==="string"&&L.data.slice(0,11)==="data:image/")return L}return null}
function crier(){
  if(alerte)return; alerte=true;
  try{
    var d=document.createElement("div");
    d.setAttribute("role","alert");
    d.style.cssText="position:fixed;left:0;right:0;bottom:0;z-index:2147483000;background:#8a1c1c;color:#fff;padding:14px 18px;font:600 15px/1.4 system-ui,-apple-system,sans-serif;text-align:center";
    d.textContent="Ton logo n'a pas pu être chargé dans ton navigateur. Recharge la page, ou écris-nous : on termine ta commande avec toi.";
    (document.body||document.documentElement).appendChild(d);
  }catch(e){}
}
function reparer(){
  degager();
  if(lire(CLE))return;
  var L=choisi(); if(!L)return;
  if(poser(CLE,L.data)){if(L.tone)poser(TON,L.tone);oter(SANS);return}
  crier();
}
try{reparer()}catch(e){}
try{setInterval(function(){try{reparer()}catch(e){}},1200)}catch(e){}
try{window.addEventListener("pageshow",function(){try{reparer()}catch(e){}})}catch(e){}
try{document.addEventListener("visibilitychange",function(){if(!document.hidden){try{reparer()}catch(e){}}})}catch(e){}
})();